import { AdgroupFormData, CampaignFormData, DevicePriceType } from '@tt4b/ttam-enums';
import { ValidationError, useStdAdgroupIs } from '@tt4b/ttam-hooks';

import { computed, Ref } from '@vue/composition-api';
import { i18n } from './../../../i18n';

export function useRules() {
  return {
    devicePriceValidator: computed(() => [
      {
        validator: (rule, value, callback, data: AdgroupFormData) => {
          const { deviceType, launchPrice } = data;
          const minPrice = launchPrice?.[0];
          const maxPrice = launchPrice?.[1];
          if (deviceType === DevicePriceType.RANGE) {
            // -1 定义为不可用的 number 值
            const __nan = -1;
            const min = minPrice === undefined ? __nan : minPrice;
            const max = maxPrice === undefined ? __nan : maxPrice;
            if (min === __nan || max === __nan || min >= max) {
              return callback(
                new ValidationError({
                  messageI18nKey: 'adgroup_device_error_hint',
                  message: i18n.t('adgroup_device_error_hint'),
                  moduleName: i18n.t('adgroup_audience_target'),
                  subModuleName: i18n.t('adgroup_device_price'),
                }),
              );
            }
          }
          return callback();
        },
        trigger: 'change',
      },
    ]),
  };
}

export function usePriceRangePropsDisabled(opt: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { isSelectedIndustryType } = useStdAdgroupIs({
    adgroupFormData: opt.adgroupData,
    campaignFormData: opt.campaignData,
  });
  /** 选择了设备机型，不能设置价格范围 */
  const priceRangeDisabled = computed(
    () => Boolean(opt.adgroupData.value.deviceModels?.length) || isSelectedIndustryType.value,
  );
  return {
    priceRangeDisabled,
  };
}

export function useDevicePriceRangePropsVisible(opt: { adgroupData: Ref<AdgroupFormData> }) {
  const devicePriceRangeVisible = computed(() => opt.adgroupData.value.deviceType === DevicePriceType.RANGE);
  return {
    devicePriceRangeVisible,
  };
}

export function useMinAndMaxOptions() {
  const createDevicePrice = (mix = 0, max = 1000, setup = 50, isPlus = 0) => {
    const devicePriceList: {
      label: string;
      value: number;
    }[] = [];
    let i = mix || 0;
    do {
      let label = `${i}`;
      let val = i;

      if (i === max && isPlus) {
        label = `${isPlus}+`;
        val = 10000;
      }
      devicePriceList.push({ label: `${label}`, value: val });
      i += setup;
    } while (i <= max);
    return devicePriceList;
  };
  // 固定配置
  const setup = 50;
  const min = 0;
  const max = 1000;
  const minOptions = createDevicePrice(min, max, setup);
  const maxOptions = createDevicePrice(min + setup, max + setup, setup, max);
  return {
    createDevicePrice,
    minOptions,
    maxOptions,
  };
}

export function usePropDevicePrice(options: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = options;
  const { minOptions, maxOptions } = useMinAndMaxOptions();
  const devicePrice = computed(() => {
    if (adgroupData.value.deviceType === DevicePriceType.RANGE) {
      const { launchPrice } = adgroupData.value;
      const min = minOptions.find(item => item.value === launchPrice[0])?.label;
      const max = maxOptions.find(item => item.value === launchPrice[1])?.label;

      return `${min} ~ ${max} USD`;
    } else {
      return '';
    }
  });

  return {
    devicePrice,
  };
}
